import axios from 'axios'

import Vue from 'vue';
//返回接口地址
export function url() {
    return Vue.prototype.url
}
//登录接口
export function login(data) {
    return axios({
      method: 'post',
      url: Vue.prototype.url + '/auth/login',
      data:data
    })
}

//正式
export function getdoown(data) {
  return axios({
    method: 'get',
    url: 'https://sport.luojiweiye.com/api/apps/latest_version',
    params:data
  })
}

//测式

// export function getdoowndev(data) {
//   return axios({
//     method: 'get',
//     url: 'https://rockysports.cn/api/versionApp',
//     params:data
//   })
// }
